<!-- TEMPLATE -->
<template>
  <div class="dean-sidemenu">
    <div class="row">
      <dean-sidemenu-column
        v-for="sidebar in data"
        class="dean-sidemenu-column"
        :data="sidebar"
        :key="sidebar.title.text"
        :theme="sidebar.type"
        :title-bar="sidebar.titlebar"
        @dean-sidemenu-mobile-item-click="deanSidemenuMobileItemClick"
        @dean-sidemenu-title-item-click="deanSidemenuTitleItemClick"
        @dean-sidemenu-item-click="deanSidemenuItemClick"
        @close="deanSidemenuCloseClick"
      ></dean-sidemenu-column>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanSidemenuColumn from './deanSidemenuColumn.vue';

@Component({
  components: {
    deanSidemenuColumn
  }
})
export default class deanSidemenu extends Vue {
  //PROPS
  @Prop() data!: object;

  deanSidemenuItemClick(item: object) {
    this.$emit('dean-sidemenu-click', item);
  }

  deanSidemenuMobileItemClick(item: string) {
    this.$emit('dean-sidemenu-mobile-click', item);
  }

  deanSidemenuTitleItemClick(item: string) {
    this.$emit('dean-sidemenu-title-click', item);
  }

   deanSidemenuCloseClick(item: string) {
    this.$emit('close');
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.dean-sidemenu {
  @include calc(min-height, '100vh - 80px');
  z-index: 997;
  .dean-sidemenu-column, .row {
    min-height: 100%;
  }
}
</style>
